export default "__VITE_ASSET__CfTpUmIt__"